export default __webpack_public_path__ + "static/media/1.4eefc315.jpg";